export default __webpack_public_path__ + "static/media/bca_logo.e7b598c6.png";